/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import axios from 'axios';
import PropTypes from 'prop-types';

import FunctionalCheckbox from './FunctionalCheckbox';

const FeaturedItemsModal = ({
  showSelectModal,
  handleCloseModalClick,
  itemsArray,
  setShowSelectModal,
  featuredIdList,
  catalogID,
  setRefreshData,
}) => {
  const [selectedCount, setSelectedCount] = useState();
  const [selectedItemArray, setSelectedItemArray] = useState([]);
  const [showErrrorText, setShowErrorText] = useState(false);
  const [showBannedText, setShowBannedText] = useState(false);

  useEffect(() => {
    setSelectedItemArray(featuredIdList);
    setSelectedCount(featuredIdList.length);
    setRefreshData(false);
  }, [featuredIdList]);

  const handleCheckboxClick = (e) => {
    const currentID = e.currentTarget.value;
    const isChecked = e.target.checked;
    const prevArray = selectedItemArray;
    setShowErrorText(false);

    if (selectedItemArray.length === 5 && isChecked) {
      setShowErrorText(true);
    } else {
      if (isChecked) {
        prevArray.push(Number(currentID));
      } else {
        const selectedIndex = prevArray.indexOf(Number(currentID));
        prevArray.splice(selectedIndex, 1);
      }

      let bannerFlag = false;
      itemsArray.forEach(item => {
        if (prevArray.indexOf(item.id) > -1 && item.banned) {
          bannerFlag = true;
        }
      });
      setShowBannedText(bannerFlag);

      setSelectedCount(selectedItemArray.length);
      setSelectedItemArray(prevArray);
    }
  };

  const saveFeaturedLots = async () => {
    const postUrl = `/cps/app/featuredLots/catalog/${catalogID}`;
    try {
      await axios.post(
        postUrl,
        selectedItemArray,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );
    } catch (error) {
      console.log('post api error');
    }

    setShowSelectModal(false);
    setRefreshData(true);
  };

  return (
    <Modal isOpen={showSelectModal} className="step-6-modal cover-photo-modal position-relative" centered id="featuredModal">
      <ModalHeader className="pb-0 ml-4" tag="h1">
        Select Featured Items
      </ModalHeader>
      <ModalBody className="py-0 mx-4">
        <div className="ml-3">
          Choose 5 items from your sale to highlight at the top of the catalog.
        </div>
        {showBannedText && (
          <div className="error-text ml-3">
            A banned lot has been selected and is ineligible to be featured.  Select 5 unbanned featured lots.
          </div>
        )}
        <div className="ml-3 mt-4">
          <span className="font-weight-bold">{selectedCount} of 5 selected</span>
          <span className={`error-text ml-4 ${showErrrorText ? '' : 'd-none'}`}>You must deselect an item before selecting a new one</span>
        </div>
        <div className="cover-photo-body">
          <FunctionalCheckbox
            columnCount={4}
            columnWidth={185}
            items={itemsArray.map((item) => ({
              lotNum: item.comboNum,
              src: item.url,
              id: item.id,
              title: item.title,
              banned: item.banned,
              checked: featuredIdList.indexOf(item.id) > -1
            }))}
            labelKey="lotNum"
            rowHeight={250}
            width={760}
            maxHeight={580}
            handleCheckboxClick={handleCheckboxClick}
            selectedItemArray={selectedItemArray}
          />
        </div>
      </ModalBody>
      <ModalFooter className="featured-save-button">
        <Button
          className={`${selectedCount < 5 || showBannedText ? ' disabled-cursor' : ''}`}
          color="primary"
          disabled={selectedCount < 5 || showBannedText}
          onClick={() => {
            saveFeaturedLots();
          }}
        >
          Save Changes
        </Button>
        <Button
          color="link"
          className="ml-4"
          onClick={() => handleCloseModalClick()}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

FeaturedItemsModal.propTypes = {
  showSelectModal: PropTypes.bool.isRequired,
  handleCloseModalClick: PropTypes.func.isRequired,
  itemsArray: PropTypes.array.isRequired,
  setShowSelectModal: PropTypes.func.isRequired,
  featuredIdList: PropTypes.array.isRequired,
  catalogID: PropTypes.number.isRequired,
  setRefreshData: PropTypes.func.isRequired,
};

export default FeaturedItemsModal;
